import React, { useEffect, useState } from 'react'

// import ItemAdded from '../utils/itemAdded'

const ProductShopLink = ({ productHandle }) => {
  const [productData, setProductData] = useState()
  const [isAddingCart, setIsAddingCart] = useState(false)
  const [sizeOptions, setSizeOptions] = useState()

  useEffect(() => {
    const getProductInfo = async () => {
      const resProduct = await fetch(`/products/${productHandle}.js`, {
        headers: {
          'Content-Type': 'application/json',
          pragma: 'no-cache',
          'cache-control': 'no-cache',
        },
        credentials: 'same-origin',
      })
      const data = await resProduct.json()

      for (let i = 0; i < data.options.length; i++) {
        if (data.options[i].name === 'Size') {
          setSizeOptions(data.options[i].values)
          break
        }
      }

      setProductData(data)
    }

    getProductInfo()
  }, [])

  const onAddToCart = async (e, selectedVariant) => {
    e.preventDefault()
    setIsAddingCart(true)
    const resCart = await fetch('/cart/add.js', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: selectedVariant.id,
          },
        ],
      }),
    })
    const data = await resCart.json()
    // addToast(<ItemAdded product={productData} variant={selectedVariant} />, {
    //   appearance: 'success',
    // })
    document.getElementById('btn_cart').click()
    setIsAddingCart(false)
    updateCartCount()
  }

  const updateCartCount = async () => {
    const resCart = await fetch('/cart.js', {
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
    })
    const data = await resCart.json()
    document.getElementById('cart_count').textContent = data.item_count
  }

  const onClickQuickShop = (e) => {
    const hasSizeOptions = !!productData.options.find((x) => {
      return x.name === 'Size'
    })

    if (!hasSizeOptions && productData.variants.length >= 0) {
      const availableProductVariant = productData.variants.find((x) => {
        return x.available === true
      })
      if (availableProductVariant) {
        onAddToCart(e, availableProductVariant)
      }
    }
  }

  const onClickSize = (e, size) => {
    const selectedVariant = productData.variants.find((x) => {
      return x.options.includes(size)
    })

    if (selectedVariant.available) {
      onAddToCart(e, selectedVariant)
    }
  }

  return productData && productData.available ? (
    <div className='product-shop-link'>
      <a className='link-quick-shop' onClick={onClickQuickShop}>
        + Quick Shop
      </a>
      {sizeOptions && (
        <div className='product-variants'>
          <ul>
            {sizeOptions.map((size, i) =>
              productData.variants.find((x) => {
                return x.options.includes(size)
              }).available ? (
                <li key={i}>
                  <a onClick={(e) => onClickSize(e, size)}>{size}</a>
                </li>
              ) : (
                <li key={i}>
                  <a className='unavailable'>{size}</a>
                </li>
              )
            )}
          </ul>
        </div>
      )}
    </div>
  ) : (
    <div className='product-shop-link'>
      <a className='link-quick-shop'>Sold Out</a>
    </div>
  )
}

export default ProductShopLink
